const getSelectedInvoiceDataIndex = (state) => state.selectedInvoiceDataIndex;

export default {
  getSelectedInvoiceDataIndex,
};
